"use client";
import { j as e } from "../../jsx-runtime-B6kdoens.js";
import { Children as A, useMemo as w } from "react";
import { c as O, a as p } from "../../index-CROKJrb5.js";
import { c as C, f as B } from "../../create-component-CBAeEoQ6.js";
import { IconRenderer as y } from "../Icon/index.js";
import { Typography as I } from "../Typography/index.js";
import { useBrand as R } from "../../brand/context/index.js";
import { LoadingIcon as M } from "../Icon/icons/LoadingIcon/index.js";
const D = O({
  base: [
    "cur-relative",
    "cur-inline-block",
    "cur-border-2",
    "cur-font-body",
    "cur-text-body",
    "cur-tracking-body",
    "cur-transition-all"
  ],
  variants: {
    brand: {
      curology: null,
      agency: null
    },
    buttonType: {
      primary: [],
      secondary: [
        "cur-bg-surface-neutral",
        "active:cur-bg-surface-neutral-selected"
      ],
      text: "cur-border-transparent cur-group active:cur-text-primary"
    },
    disabled: {
      true: null
    },
    flush: {
      true: null
    },
    flushAndText: {
      true: null
    },
    iconOnly: {
      true: "cur-rounded-full"
    },
    loading: {
      true: null
    },
    size: {
      sm: null,
      md: null,
      lg: "cur-leading-[2]"
    },
    state: {
      brand: null,
      dark: null,
      critical: null,
      success: null
    }
  },
  compoundVariants: [
    // Small Buttons
    {
      size: "sm",
      flush: !1,
      flushAndText: !1,
      className: "cur-h-[2.5rem]"
    },
    {
      size: "sm",
      flush: !1,
      iconOnly: !0,
      className: "cur-w-[2.5rem]"
    },
    {
      size: "sm",
      flushAndText: !1,
      iconOnly: !1,
      className: "cur-py-2 cur-px-4"
    },
    // Small/Medium Buttons
    {
      size: ["sm", "md"],
      className: "cur-leading-[1.5]"
    },
    // Medium Buttons
    {
      size: "md",
      flush: !1,
      flushAndText: !1,
      className: "cur-h-[3.5rem]"
    },
    {
      size: "md",
      flush: !1,
      iconOnly: !0,
      className: "cur-w-[3.5rem]"
    },
    {
      size: ["md", "lg"],
      flushAndText: !1,
      iconOnly: !1,
      className: "cur-py-4 cur-px-6"
    },
    // Large Buttons
    {
      size: "lg",
      flush: !1,
      flushAndText: !1,
      className: "cur-h-[4rem]"
    },
    {
      size: "lg",
      flush: !1,
      iconOnly: !0,
      className: "cur-w-[4rem]"
    },
    // Text Buttons
    {
      buttonType: "text",
      disabled: !1,
      iconOnly: !0,
      loading: !1,
      className: "hover:cur-bg-surface-highlight"
    },
    // Primary Buttons
    {
      buttonType: "primary",
      disabled: !1,
      className: "cur-text-inverse"
    },
    {
      buttonType: "primary",
      disabled: !0,
      loading: !1,
      className: "cur-border-surface-disabled"
    },
    {
      buttonType: "primary",
      state: "brand",
      disabled: !1,
      className: [
        "cur-bg-surface-brand",
        "cur-border-surface-brand",
        "hover:cur-bg-surface-brand-hover",
        "hover:cur-border-surface-brand-hover",
        "active:cur-border-surface-brand-selected",
        "active:cur-bg-surface-brand-selected"
      ]
    },
    {
      buttonType: "primary",
      state: "dark",
      disabled: !1,
      className: [
        "cur-bg-surface-secondary",
        "hover:cur-bg-surface-secondary-hover",
        "active:cur-bg-surface-secondary-selected",
        "hover:cur-border-surface-secondary-hover",
        "active:cur-border-surface-secondary-selected"
      ]
    },
    {
      buttonType: "primary",
      state: "critical",
      disabled: !1,
      className: [
        "cur-bg-surface-error-bold",
        "hover:cur-bg-surface-error-bold-hover",
        "active:cur-bg-surface-error-bold-selected",
        "hover:cur-border-surface-error-bold-hover",
        "active:cur-border-surface-error-bold-selected"
      ]
    },
    {
      buttonType: "primary",
      state: "success",
      disabled: !1,
      className: [
        "cur-border-surface-success-bold",
        "cur-bg-surface-success-bold",
        "hover:cur-bg-surface-success-bold-hover",
        "active:cur-bg-surface-success-bold-selected",
        "hover:cur-border-surface-success-bold-hover",
        "active:cur-border-surface-success-bold-selected"
      ]
    },
    // Primary/Secondary Buttons
    {
      buttonType: ["primary", "secondary"],
      className: "cur-rounded-[3.5rem]"
    },
    {
      buttonType: ["primary", "secondary"],
      disabled: !0,
      loading: !1,
      className: "cur-bg-surface-disabled"
    },
    {
      buttonType: ["primary", "secondary"],
      state: "dark",
      disabled: !1,
      className: "cur-border-border-secondary"
    },
    {
      buttonType: ["primary", "secondary"],
      state: "critical",
      disabled: !1,
      className: "cur-border-border-error"
    },
    // Secondary Buttons
    {
      buttonType: "secondary",
      disabled: !0,
      loading: !1,
      className: "cur-border-border-disabled"
    },
    {
      buttonType: "secondary",
      state: "brand",
      disabled: !1,
      className: "cur-border-surface-brand-light"
    },
    {
      buttonType: "secondary",
      state: ["brand", "dark"],
      disabled: !1,
      className: "hover:cur-bg-surface-neutral-hover"
    },
    {
      buttonType: "secondary",
      state: "critical",
      disabled: !1,
      className: [
        "hover:cur-bg-surface-error-hover",
        "active:cur-bg-surface-error-selected"
      ]
    },
    {
      buttonType: "secondary",
      state: "success",
      disabled: !1,
      className: [
        "cur-border-border-success",
        "hover:cur-bg-surface-success-hover",
        "active:cur-bg-surface-success-selected"
      ]
    },
    // Secondary or Text
    {
      buttonType: ["secondary", "text"],
      state: "brand",
      disabled: !1,
      className: "cur-text-brand"
    },
    {
      buttonType: ["secondary", "text"],
      state: "dark",
      disabled: !1,
      className: "cur-text-primary"
    },
    {
      buttonType: ["secondary", "text"],
      state: "critical",
      disabled: !1,
      className: "cur-text-error"
    },
    {
      buttonType: ["secondary", "text"],
      state: "success",
      disabled: !1,
      className: "cur-text-success"
    },
    // Disabled but not loading
    {
      disabled: !0,
      loading: !1,
      className: "cur-text-disabled"
    },
    // AGENCY
    {
      brand: "agency",
      buttonType: ["primary", "secondary"],
      className: "cur-rounded-none"
    },
    {
      brand: "agency",
      buttonType: ["primary", "secondary", "text"],
      className: "cur-uppercase cur-font-normal cur-tracking-wider"
    },
    {
      brand: "agency",
      state: "brand",
      buttonType: ["primary", "text"],
      className: "cur-text-primary"
    },
    {
      brand: "agency",
      buttonType: ["secondary"],
      className: "cur-border-surface-secondary cur-text-surface-secondary active:cur-bg-surface-secondary-selected active:cur-text-surface-primary hover:cur-bg-surface-secondary hover:cur-text-surface-primary cur-border"
    },
    {
      brand: "agency",
      disabled: !0,
      loading: !1,
      className: "cur-border-surface-disabled cur-text-disabled"
    }
  ]
}), P = ({ children: s, ...r }) => /* @__PURE__ */ e.jsx(I, { size: "meta", className: "cur-inline-block", ...r, children: s }), L = ({ children: s, disabled: r, brand: a }) => /* @__PURE__ */ e.jsx(
  "div",
  {
    className: p("cur-font-bold", {
      "group-hover:cur-underline": !r,
      "cur-font-normal": a && a === "agency"
    }),
    children: s
  }
), V = (s, r) => w(() => r && s === "lg" ? "md" : "sm", [s, r]), Q = C(
  "Typography",
  B(
    ({
      as: s,
      buttonType: r = "primary",
      children: a,
      className: g = "",
      disabled: o = !1,
      flush: d = !1,
      icon: h,
      iconEnd: n,
      iconStart: c,
      loading: t = !1,
      onClick: x,
      size: b = "md",
      state: v = "brand",
      type: N = "button",
      ...T
    }, z) => {
      const i = R();
      c = c || h;
      const j = s || "button", f = !a && !!(c || n), k = D({
        brand: i,
        buttonType: r,
        className: g,
        disabled: o,
        flush: d,
        flushAndText: d && r === "text",
        iconOnly: f,
        loading: t,
        size: b,
        state: v
      }), m = o || t, u = V(b, f);
      return /* @__PURE__ */ e.jsxs(
        j,
        {
          type: N,
          ref: z,
          className: k,
          disabled: m,
          ...T,
          onClick: x,
          children: [
            /* @__PURE__ */ e.jsxs(
              "span",
              {
                className: p(
                  "cur-flex cur-h-full cur-items-center cur-justify-center cur-text-ellipsis cur-whitespace-nowrap",
                  { "cur-invisible": t }
                ),
                children: [
                  /* @__PURE__ */ e.jsx(
                    y,
                    {
                      icon: c,
                      size: u,
                      className: a ? "cur-mr-2" : ""
                    }
                  ),
                  /* @__PURE__ */ e.jsx("span", { className: "cur-flex cur-h-full cur-items-center cur-gap-1", children: A.map(a, (l) => typeof l == "string" ? /* @__PURE__ */ e.jsx(L, { disabled: m, brand: i, children: l }) : l) }),
                  /* @__PURE__ */ e.jsx(
                    y,
                    {
                      icon: n,
                      size: u,
                      className: a ? "cur-ml-2" : ""
                    }
                  )
                ]
              }
            ),
            t && /* @__PURE__ */ e.jsx("span", { className: "cur-absolute cur-left-1/2 cur-top-1/2 -cur-translate-x-1/2 -cur-translate-y-1/2", children: /* @__PURE__ */ e.jsx(M, { size: u, className: "cur-animate-spin" }) })
          ]
        }
      );
    }
  )
);
export {
  Q as Button,
  P as ButtonMeta
};
//# sourceMappingURL=index.js.map
